import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EntryPointParams = {};

export const popupContentEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlassian-universal-create_popup-content" */ '../../components/PopupContent'
			).then((module) => module.PopupContent),
		{
			moduleId: 'universal-create-popup-content',
		},
	),
	getPreloadProps: (_params: EntryPointParams) => ({
		queries: {},
		entryPoints: {},
		extraProps: {},
	}),
});
